import ConfigParameter, { gettext } from "../ConfigParameter";

export default class LabelWidth extends ConfigParameter {

    constructor() {
        super('labelWidth', 'select', gettext('Labels width'), 'position', 2, null, [2, 3, 4, 5, 6, 7, 8]);
    }

}


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/LabelWidth.js